module.exports = __webpack_public_path__ + "static/media/Baccarat1.90766f8f.png";